import React from "react";
import Page, { PageProps } from "../Page";
import DataGrid from "../../components/app/grid/DataGrid";
import { Form } from "antd";
import { IRequestTypesPresenter } from "../../../presenter/request/RequestTypesPresenter";
import CreateRequestTypeForm, {
  CreateRequestTypeFormProps
} from "./CreateRequestTypeForm";
import UpdateRequestTypeForm, {
  UpdateRequestTypeFormProps
} from "./UpdateRequestTypeForm";
import TickBox from "../../components/app/grid/TickBox";
import Loader from "../../components/Loader";
export interface Props extends PageProps {}
export interface State extends IRequestTypesPresenter {}

export default class RequestTypesPage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe(result => {
      return this.setState(() => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    let {
      translate,
      requestTypes = [],
      createRequestType,
      updateRequestType
    } = this.state;
    const CreateForm = Form.create<CreateRequestTypeFormProps>({})(
      CreateRequestTypeForm
    );

    const UpdateForm = Form.create<UpdateRequestTypeFormProps>({})(
      UpdateRequestTypeForm
    );

    const columns = [
      {
        title: translate("requestTypes_page.code"),
        dataIndex: "code",
        key: "code"
      },
      {
        title: translate("requestTypes_page.name"),
        dataIndex: "name",
        key: "name"
      },

      {
        title: translate("requestTypes_page.valid"),
        dataIndex: "valid",
        key: "valid",
        render: (text, record) => <TickBox value={record.valid} />,
        width: "10%"
      }
    ];

    const dataGrid = (
      <DataGrid
        title={translate("grids.request-types")}
        translate={translate}
        columns={columns}
        dataSource={requestTypes}
        allowCreate={true}
        allowDelete={false}
        allowUpdate={true}
        createForm={CreateForm}
        updateForm={UpdateForm}
        onCreate={createRequestType}
        onUpdate={updateRequestType}
        createModalTitle={translate("requestTypes_page.insert_modal_title")}
        updateModalTitle={translate("requestTypes_page.update_modal_title")}
        addButtonText={translate("requestTypes_page.add_button_text")}
        booleanColumnKeys={["valid"]}
      />
    );

    return (
      <Page {...this.props}>
        <Loader
          children={dataGrid}
          translate={translate}
          loading={this.state.loaders.requestsLoader}
        />
      </Page>
    );
  }
}
